<template>
	<div class="banner-bottom">
		<el-row>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
				<div class="center-box">
					<div class="item" v-for="item in data" :key="item.id">
						<h6>{{item.content}}</h6>
						<img :src="item.img" />
					</div>
				</div>
			</el-col>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'bannerBottom',
		props: ['data']
	}
</script>

<style>
	@media (min-width:992px) {
		.banner-bottom {
			width: 100%;
			height: 120px;
			background-color: #1C5178;
		}

		.banner-bottom .center-box {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 120px;
		}

		.banner-bottom .center-box .item {
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			height: 100%;
			width: 380px;
		}

		.banner-bottom .center-box .item:nth-child(2) {
			border-left: 1px solid rgba(255, 255, 255, .1);
			border-right: 1px solid rgba(255, 255, 255, .1);
		}

		.banner-bottom .center-box .item h6 {
			font-size: 18px;
			color: #fff;
			margin-top: 30px;
		}
	}

	@media (max-width:992px) {
		.banner-bottom {
			width: 100%;
			height: 40px;
			background-color: #1C5178;
		}

		.banner-bottom .center-box {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 40px;
		}

		.banner-bottom .center-box .item {
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-items: center;
			height: 100%;
			width: 100px;
		}

		.banner-bottom .center-box .item:nth-child(2) {
			border-left: 1px solid rgba(255, 255, 255, .1);
			border-right: 1px solid rgba(255, 255, 255, .1);
		}

		.banner-bottom .center-box .item h6 {
			font-size: 18px;
			color: #fff;
			margin: 0;
		}

		.banner-bottom .center-box .item img {
			display: none;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/BannerBottom.vue